import * as React from 'react'
import * as ReactDOM from 'react-dom'

import {CustomerDropdown} from "./CustomerDropdown";

let mobile = document.getElementById("customer-mount-mobile");
let desktop = document.getElementById("customer-mount-desktop");

mount();

window.addEventListener('resize', () => {
    mount();
});

function mount() {
    if (window.innerWidth > 768) {
        ReactDOM.render(<CustomerDropdown/>, desktop);
        ReactDOM.unmountComponentAtNode(mobile)
    }
    else {
        ReactDOM.render(<CustomerDropdown/>, mobile);
        ReactDOM.unmountComponentAtNode(desktop)
    }
}

